import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import Card          from '@common/influencer/_card';
// -------------------------------------------------------

class ProgressCard extends React.Component {
  render() {
    let influencer = this.props.data;
    let base = this.props.base;
    
    return (
      <li data-id={influencer.insta_user_id}>
        <Card data={influencer} option={['is_not_info','is_not_import_action','is_popup', 'is_guest']} />
      </li>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProgressCard;